import {VideoService} from './video.service';

export const VideoInjectables: Array<any> = [
  {
    provide: VideoService,
    useClass: VideoService,
  },
];
